module.exports = __webpack_public_path__ + "static/media/TOSA_carouge.ce5f7802.webp";